import { render, staticRenderFns } from "./DriverAppViewDocument.vue?vue&type=template&id=2fbdac7a&scoped=true"
import script from "./DriverAppViewDocument.vue?vue&type=script&lang=js"
export * from "./DriverAppViewDocument.vue?vue&type=script&lang=js"
import style0 from "./DriverAppViewDocument.vue?vue&type=style&index=0&id=2fbdac7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbdac7a",
  null
  
)

export default component.exports